import { faCircle } from "@fortawesome/pro-solid-svg-icons";
import { useNavigate } from "react-router-dom";

import { ROUTE_CONFIG } from "@/routes/config";

import { Icon } from "../Icon/Icon";
import { Button } from "../Button/Button";

export const ScoringOngoingModal = () => {
	const navigate = useNavigate();

	return (
		<div className="absolute z-30 left-0 top-0 pt-4 w-full min-h-full flex items-center justify-center">
			<div className="flex flex-col bg-white px-6 py-10 rounded-[20px] w-[656px] max-w-[100%] shadow-[0px_0px_80px_0px_rgba(171,178,217,0.35)] items-center justify-center mb-6">
				<div className="flex flex-col justify-center items-center gap-2">
					<div className="text-md font-bold mb-8">We are currently creating your lead scoring!</div>

					<div className="text-sm max-w-[500px] rounded-lg px-6 py-3 bg-background-warning mb-4">
						<b>To make the setup for you as easy as possible</b>, we will:
						<ul className="list-disc mt-1 ml-1">
							<li className="flex items-center gap-2">
								<Icon className="text-text-meta w-1 h-1" icon={faCircle} /> Analyse your website and
								other online resources.
							</li>
							<li className="flex items-center gap-2">
								<Icon className="text-text-meta w-1 h-1" icon={faCircle} /> Create a list of ideal
								customer companies.
							</li>
							<li className="flex items-center gap-2">
								<Icon className="text-text-meta w-1 h-1" icon={faCircle} /> Create a list of ideal
								customer personas.
							</li>
							<li className="flex items-center gap-2">
								<Icon className="text-text-meta w-1 h-1" icon={faCircle} /> Create an example
								scoring.
							</li>
						</ul>
					</div>
					<div className="flex flex-row gap-2 mb-4">
						<div className="text-smd max-w-[300px] flex flex-col items-center gap-2 text-center px-4 py-3">
							<p>
								<b>This might take a while. Come back in a few minutes...</b>
							</p>
						</div>
					</div>

					<div className="w-auto">
						<Button
							title="Go back to your lists"
							onClick={() => {
								navigate(ROUTE_CONFIG.LISTS);
							}}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};
